import { atom } from 'recoil'
import { InspectorCheckResult } from '../../inspection.types'

interface ICheckResultsTableAtomState {
  items: InspectorCheckResult[]
  filters: {
    search?: string
  }
}

const checkResultsTableAtom = atom<ICheckResultsTableAtomState>({
  key: 'tables/inspector/checkResults',
  default: { items: [], filters: { search: '' } },
})

export default checkResultsTableAtom
